<template>
  <el-dialog
    :title="$t('deleteAffiliateProduct.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('deleteAffiliateProduct.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('deleteAffiliateProduct.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ $t('deleteAffiliateProduct.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAffiliateProduct } from '@/api/affiliate/affiliateProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateProduct',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        apId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteData = {
        apId: row.apId,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteData = {
        apId: '',
        shopId: ''
      }
    },
    async handleConfirm() {
      try {
        await deleteAffiliateProduct(this.deleteData)
        this.$message.success(this.$t('deleteAffiliateProduct.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>